import { deferUntilUserIntent } from "./deferThirdParty";

const shouldInitializeSentry = () =>
  process.env.REACT_APP_IS_PROD === "true" &&
  typeof window !== "undefined" &&
  !window.location.host.includes("localhost") &&
  !window.location.host.includes("dev.hotelzify.com") &&
  !window.location.host.includes("dev-hotelzify.com");

let sentryPromise;

export const initializeSentry = () => {
  if (!shouldInitializeSentry()) {
    return Promise.resolve(null);
  }

  if (!sentryPromise) {
    sentryPromise = import("@sentry/react")
      .then((Sentry) => {
        Sentry.init({
          dsn: "https://e2ed10825e3b86bcd09d054ecc56c6d4@o4505484329353216.ingest.us.sentry.io/4508567072014336",
          integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({ maskAllText: false }),
            Sentry.captureConsoleIntegration({ levels: ["error"] }),
            Sentry.extraErrorDataIntegration({ depth: 10 }),
            Sentry.httpClientIntegration(),
          ],
          // The global handlers and the console integration below capture the
          // whole page, not just our bundle — including the chat widget and
          // per-hotel custom scripts we inject. Tearing down a media element
          // while play() is still pending rejects with an AbortError; that is
          // normal teardown, not a fault (see goo.gl/LdLk22), and it is what
          // our own <video> teardown in HotelVideos already catches.
          ignoreErrors: [/The play\(\) request was interrupted/],
          tracesSampleRate: 1.0,
          environment: "Prod",
          replaysSessionSampleRate: 0.1,
          replaysOnErrorSampleRate: 1.0,
        });
        return Sentry;
      })
      .catch(() => null);
  }

  return sentryPromise;
};

export const deferSentryInitialization = () => {
  if (!shouldInitializeSentry()) return;
  deferUntilUserIntent(() => {
    void initializeSentry();
  });
};

export const captureException = (error, options = {}) => {
  void initializeSentry().then((Sentry) => {
    if (!Sentry) return;
    Sentry.captureException(error, options);
  });
};

export const reportException = (error, info) => {
  captureException(error, {
    contexts: {
      react: {
        componentStack: info?.componentStack,
      },
    },
  });
};
